import React from 'react';
import { Grid, Typography, Card, CardContent, Alert } from '@mui/material';
import { toast } from 'react-toastify';
import { useThemeMode } from '../hooks/useThemeMode';
import FaucetCard, { FAUCET_DATA } from '../components/FaucetCard';

const handleAddChainToMetaMask = async (chainParams) => {
  if (!window.ethereum) {
    toast.error('MetaMask not detected. Please install MetaMask to add networks.');
    return;
  }

  try {
    await window.ethereum.request({
      method: 'wallet_addEthereumChain',
      params: [chainParams],
    });
    toast.success(`${chainParams.chainName} added to MetaMask successfully!`);
  } catch (error) {
    console.error('Error adding chain to MetaMask:', error);
    if (error.code === 4001) {
      toast.error('User rejected the request');
    } else {
      toast.error(`Failed to add ${chainParams.chainName}: ${error.message}`);
    }
  }
};

const Faucet = () => {
  const { isDark } = useThemeMode();

  return (
    <Card sx={{ background: isDark ? '#0a0a0a' : '#ffffff', border: `1px solid ${isDark ? '#262626' : '#e5e5e5'}` }}>
      <CardContent>
        <Typography variant="h6" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          💧 Testnet Faucets & Network Setup
        </Typography>
        <Alert severity="info" sx={{ mb: 3 }}>
          Get free testnet tokens to try out the treasury dashboard. Click on a faucet link to receive tokens, or use "Add to MetaMask" to quickly configure your wallet.
        </Alert>

        <Grid container spacing={2}>
          {FAUCET_DATA.map((faucet) => (
            <FaucetCard
              key={faucet.name}
              {...faucet}
              isDark={isDark}
              onAddToMetaMask={handleAddChainToMetaMask}
            />
          ))}
        </Grid>
      </CardContent>
    </Card>
  );
};

export default Faucet;
